import {
  Box,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

// Mirrors AffordableWaitlistActions/SelectFromWaitlist's own read-only
// field: label above value, no input chrome. Used for system-tracked data
// a property manager can never edit, where a disabled input would imply
// it is editable somewhere.
export const renderReadOnlyField = ({ label, value }) => (
  <Box>
    <Typography variant="labelLarge" component="div">
      {label}
    </Typography>
    <Typography variant="bodyMedium" component="div">
      {value || '---'}
    </Typography>
  </Box>
);

export default renderReadOnlyField;
